import React from 'react'
import { useNavigate } from 'react-router-dom'
import WaterPreventiveWorkCard from './WaterPreventiveWorkCard'
import { useAuthState } from '../../../../../Helper/Context';
import { useDispatch } from 'react-redux';


export default function WaterPreventiveWorkCardManage(props) {
    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName, DashProjectTypeId } = props

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, RoleID } = userDetails.user

    const dispatch = useDispatch()

    const PreventiveWorkNavigate = (name, screenFlag) => {
        if (name === "Water Pressure") {
            navigate(`/waterpressurepreventiveworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Water Flow") {
            navigate(`/waterflowpreventiveworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Water Quantity") {
            navigate(`/waterquantitypreventiveworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Chemical Supply") {
            navigate(`/chemicalsupplypreventiveworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Water Audit") {
            navigate(`/waterauditpreventiveworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Energy Consumption") {
            navigate(`/energyconsumptionpreventiveworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Security") {
            navigate(`/watersecuritypreventiveworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "House Keeping") {
            navigate(`/waterhousekeepingpreventiveworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Valve  Operation") {
            navigate(`/watervalveoperationpreventiveworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Distribution Network") {
            navigate(`/watersupplydistributionnetworkpreventiveworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
    }
    const navigate = useNavigate()
    // console.log('DashProjectTypeId',DashProjectTypeId)
    return (
        <div>
            <div className="row ps-lg-3 pe-lg-3">
                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WaterPreventiveWorkCard
                        title="Water Pressure"
                        imgPath='./assets/img/waterpressure.png'
                        count={Countdata.WaterPressureTotalCount ? Countdata.WaterPressureTotalCount : '0'}
                        // navLink='/waterpressurepreventiveworkpage'
                        PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WaterPreventiveWorkCard
                        title="Water Flow"
                        imgPath='./assets/img/water-waves.png'
                        count={Countdata.WaterFlowTotalCount ? Countdata.WaterFlowTotalCount : '0'}
                        // navLink='/waterflowpreventiveworkpage'
                        PreventiveWorkNavigate={PreventiveWorkNavigate}

                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WaterPreventiveWorkCard
                        title="Water Quantity"
                        imgPath='./assets/img/waterquantity.png'
                        count={Countdata.WaterQuantityTotalCount ? Countdata.WaterQuantityTotalCount : "0"}
                        // navLink='/waterquantitypreventiveworkpage'
                        PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WaterPreventiveWorkCard
                        title="Chemical Supply"
                        imgPath='./assets/img/chemistry.png'
                        count={Countdata.ChemicalSupplyTotalCount ? Countdata.ChemicalSupplyTotalCount : '0'}
                        // navLink='/chemicalsupplypreventiveworkpage'
                        PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WaterPreventiveWorkCard
                        title="Water Audit"
                        imgPath='./assets/img/audit.png'
                        count={Countdata.WaterAuditTotalCount ? Countdata.WaterAuditTotalCount : '0'}
                        // navLink='/waterauditpreventiveworkpage'
                        PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WaterPreventiveWorkCard
                        title="Energy Consumption"
                        imgPath='./assets/img/energy-consumption.png'
                        count={Countdata.EnergyConsumptionTotalCount ? Countdata.EnergyConsumptionTotalCount : '0'}
                        // navLink='/energyconsumptionpreventiveworkpage'
                        PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WaterPreventiveWorkCard
                        title="Security"
                        imgPath='./assets/img/insurance.png'
                        count={Countdata.SecurityTotalCount ? Countdata.SecurityTotalCount : '0'}
                        // navLink='/watersecuritypreventiveworkpage'
                        PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WaterPreventiveWorkCard
                        title="House Keeping"
                        imgPath='./assets/img/house-cleaning.png'
                        count={Countdata.HouseKeepingTotalCount ? Countdata.HouseKeepingTotalCount : '0'}
                        // navLink='/waterhousekeepingpreventiveworkpage'
                        PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WaterPreventiveWorkCard
                        title="Valve  Operation"
                        imgPath='./assets/img/valueoperaton.png'
                        count={Countdata.ValveOperationTotalCount ? Countdata.ValveOperationTotalCount : '0'}
                        // navLink='/watervalveoperationpreventiveworkpage'
                        PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                {
                    DashProjectTypeId == '6' && RoleID != '16' ?
                        <>
                            <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                                <WaterPreventiveWorkCard
                                    title="Distribution Network"
                                    imgPath='./assets/img/distributed.png'
                                    count={Countdata.DistributionNetworkTotalCount ? Countdata.DistributionNetworkTotalCount : '0'}
                                    // navLink='/watervalveoperationpreventiveworkpage'
                                    PreventiveWorkNavigate={PreventiveWorkNavigate}
                                />
                            </div>
                        </>
                        :
                        <></>
                }

            </div>

        </div>

    )

}
